











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CommonLayerDrawer from '@/views/designEditor/canvasWindow/layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';


import { Design } from "@/model/document2/page/surface/design/design"

import { UnitHelper } from '@/helper/unitHelper';

import * as def from "@/definitions";
@Component({
    components: {
      CommonLayerDrawer
    }
})
export default class DesignView extends Vue {
    @Prop() private design! : Design;
    @Prop() private isSelected! : boolean;
    @Prop() private index! : number;

    select()
    {
        this.$emit("select" , this.index);
    }

    // viewBox幅
    private get viewWidth() : number
    {
        return UnitHelper.convert(this.design.width, "mm", "px");
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return UnitHelper.convert(this.design.height, "mm", "px");
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get allLayers()
    {
        return this.design.getAllLayers(false);
    }

    private get scale()
    {
        return UnitHelper.convert(1, "mm", "px");
    }

    private get svgStyle()
    {
        var w = 100;
        var h = 100;
        if(this.design.height > this.design.width)
        {
            w = h * this.design.width / this.design.height;
        }
        else
        {
            h = w * this.design.height / this.design.width;
        }
        var x = (100 - w) / 2;
        var y = (100 - h) / 2;

        return {
            position: "absolute",
            top: y + "%",
            left: x + "%",
            width: w + "%",
            height: h + "%"
        };
    }

    private get transform()
    {
        var transform = "";
        return transform;
    }

    //色
    private get userConfigBorderColor(){
        var style = {
            border : "solid 4px " + this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

}
